import {
  shape,
  string,
} from 'prop-types';

const emailForm = shape({
  copyTo: string,
  recipient: string,
  subject: string,
  body: string,
});

export default emailForm;
